import React from 'react'

import { getSemanticDate } from '@utils/dayjs'

import styles from './styles.module.css'

const Content = ({ entry }) => {
  return (
    <div className={styles.details}>
      <header>{getSemanticDate(entry.createdAt)}</header>
      <p>{entry.text}</p>
    </div>
  )
}

export default Content
